"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _Typography = require("../Typography");

var _useAvatarIcon = _interopRequireDefault(require("./hooks/useAvatarIcon"));

var _useGravatar3 = _interopRequireDefault(require("./hooks/useGravatar"));

var _useInitials = _interopRequireDefault(require("./hooks/useInitials"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var GravatarImg = _styledComponents.default.img.withConfig({
  displayName: "AvatarContent__GravatarImg",
  componentId: "sc-1jejgqy-0"
})(["border-radius:50%;width:100%;"]);

var Initials = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'span'
}).withConfig({
  displayName: "AvatarContent__Initials",
  componentId: "sc-1jejgqy-1"
})(["color:", ";font-size:inherit;text-transform:uppercase;"], (0, _toColorString.default)(_designTokens.color.base.snowWhite));

var AvatarIcon = _styledComponents.default.div.withConfig({
  displayName: "AvatarContent__AvatarIcon",
  componentId: "sc-1jejgqy-2"
})(["color:", ";"], (0, _toColorString.default)(_designTokens.color.base.snowWhite));

function AvatarContent(props) {
  var _useGravatar = (0, _useGravatar3.default)(props),
      _useGravatar2 = _slicedToArray(_useGravatar, 2),
      gravatarProps = _useGravatar2[0],
      shouldUseGravatar = _useGravatar2[1];

  var initials = (0, _useInitials.default)(props);
  var avatarIconProps = (0, _useAvatarIcon.default)(props);

  switch (true) {
    case shouldUseGravatar:
      return _react.default.createElement(GravatarImg, gravatarProps);

    case !!initials.length:
      return _react.default.createElement(Initials, null, initials);

    default:
      return _react.default.createElement(AvatarIcon, avatarIconProps);
  }
}

var _default = AvatarContent;
exports.default = _default;